import styled from 'styled-components';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {
    dFlex, dFlexColumn, dFlexColumnCenter,
    alignCenter, alignStretch, alignContentCenter, flexWrap, flexRow, justifyBetween
} from '../../../../../../../globalVariables/GlobalFlex';

export const board = styled.div`
  ${dFlexColumn}
  direction: ${p => p.theme.rtl ? 'rtl' : 'ltr'};
  width: 100%;
  background: var(--TA-color-bg-base);
  border: 1px solid var(--TA-color-border-subtle);
  border-radius: var(--radius-xl);
  height: 484px;
  overflow: hidden auto;
  scrollbar-width: thin;
  &::-webkit-scrollbar{ width: 6px; }
  &::-webkit-scrollbar-thumb{
    background: var(--TA-color-border-subtle);
    border-radius: var(--radius-full);
  }
  ${mobileMedia}{ height: 950px; }
`;
export const boardRow = styled.div`
  ${dFlex}
  ${alignStretch}
  &:not(:last-child){
    border-bottom: 1px solid var(--TA-color-border-subtle);
  }
  ${mobileMedia}{
    flex-direction: column;
  }
`;
export const timePill = styled.div`
  ${dFlexColumnCenter}
  width: 60px;
  flex-shrink: 0;
  align-self: stretch;
  box-sizing: border-box;
  padding: var(--space-sm) 0;
  background: var(--TA-color-bg-surface-default);
  border-inline-end: 1px solid var(--TA-color-border-subtle);
  ${mobileMedia}{
    width: 100%;
    ${flexRow}
    ${justifyBetween}
    padding: 6px var(--space-lg);
    border-inline-end: none;
    border-bottom: 1px solid var(--TA-color-border-subtle);
  }
`;
export const timeText = styled.div`
  font-size: ${tokens.typography.fontSize.caption};
  font-weight: ${tokens.typography.fontWeight.medium};
  line-height: 18px;
  color: var(--TA-color-text-subtle);
  white-space: nowrap;
  transform: rotate(${p => p.theme.rtl ? '90deg' : '-90deg'});
  ${mobileMedia}{ transform: none; }
`;
export const tiles = styled.div`
  ${dFlex}
  ${flexWrap}
  ${alignContentCenter}
  ${alignCenter}
  gap: var(--space-sm);
  flex: 1;
  padding: var(--space-sm);
  ${mobileMedia}{ padding: 10px; }
`;
